import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { SpecialOfferFormContext } from 'context';
import type { ComponentMode, SpecialOffer as SpecialOfferConfig } from 'types';

import { SpecialOfferForm, SpecialOfferHeader } from './components';

type SpecialOfferProps = {
  mode: ComponentMode;
};

export default function SpecialOffer({ mode }: SpecialOfferProps) {
  const data = useLoaderData() as SpecialOfferConfig | undefined;

  const { title: specialOfferTitle } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const title = isUpdatedMode ? specialOfferTitle : 'افزودن تخفیف ویژه جدید';
  const defaultTitle = isUpdatedMode ? specialOfferTitle : '';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <SpecialOfferHeader>{title}</SpecialOfferHeader>
      <SpecialOfferFormContext
        mode={mode}
        defaultTitle={defaultTitle}
        {...(isUpdatedMode ? data : {})}
      >
        <SpecialOfferForm />
      </SpecialOfferFormContext>
    </React.Fragment>
  );
}
